import type { ServiceUniqueName } from '@bv/api/user';

export type BillingMode = 'bevatel' | 'zoho';

export type BillingStatus = 'active' | 'grace' | 'trial' | 'pending' | 'paused' | 'expired' | 'cancelled' | 'deleted';

type BillingStatusPolicy = Record<
  BillingStatus,
  {
    canAccessService: boolean;
  }
>;

export type SubscribableServiceUniqueName = (typeof SUBSCRIBABLE_SERVICE_UNIQUE_NAMES)[number];

export const SUBSCRIBABLE_SERVICE_UNIQUE_NAMES = [
  'call-center',
  'new-chat',
] as const satisfies readonly ServiceUniqueName[];

export const BILLING_STATUS_POLICY = {
  active: {
    canAccessService: true,
  },
  grace: {
    canAccessService: true,
  },
  trial: {
    canAccessService: true,
  },
  pending: {
    canAccessService: false,
  },
  paused: {
    canAccessService: false,
  },
  expired: {
    canAccessService: false,
  },
  cancelled: {
    canAccessService: false,
  },
  deleted: {
    canAccessService: false,
  },
} as const satisfies BillingStatusPolicy;

export const ACCESSIBLE_BILLING_STATUSES = (Object.keys(BILLING_STATUS_POLICY) as BillingStatus[]).filter(
  (status) => BILLING_STATUS_POLICY[status].canAccessService,
);
